import { Grid } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import FormField from '../FormField';

interface GuiPropertySectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
}

export default function GuiPropertySection({
  control,
  errors,
}: GuiPropertySectionProps) {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        {/*  <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
          {t('createGuiVersionPage.guiProperty')}
        </Typography> */}
      </Grid>
      <Grid item xs={12}>
        <FormField
          name="guiName"
          control={control}
          errors={errors}
          label={t('createGuiVersionPage.guiName')}
        />
      </Grid>
      <Grid item xs={12}>
        <FormField
          name="description"
          control={control}
          errors={errors}
          label={t('createGuiVersionPage.description')}
          multiline
          rows={1}
        />
      </Grid>
    </>
  );
}
